/**
 * React side of the Portal text overlay: load the published overrides of a locale (once, in the background) and
 * return a number that changes whenever overrides are applied. Put it in a useMemo dependency list next to the locale
 * so the translator is rebuilt and the screens re-render with the new wording.
 */
import { useEffect, useSyncExternalStore } from 'react';
import { getTextOverridesVersion, subscribeTextOverrides, type Locale } from '@qm/i18n';
import { loadUiText } from './ui-text';

export function useTextOverrides(locale: Locale): number {
  // main.tsx applies the copy kept from the last visit before the first paint; the network answer follows in the effect.
  const version = useSyncExternalStore(subscribeTextOverrides, getTextOverridesVersion, getTextOverridesVersion);
  useEffect(() => { void loadUiText(locale); }, [locale]);
  return version;
}
